import React from "react";
import ZylaLogo from "../assets/images/zyla-logo-circular-2.png";
import "./GoldenBanner.css";
const GoldenBanner = () => {
  return (
    <div className="golden-banner-container">
      <div className="golden-banner-container-left">
        <div className="golden-banner-container-left-upper">
          <span>India's</span>
          <span>Most loved</span>
        </div>
        <div className="golden-banner-container-left-lower">
          <span>Healthcare Management</span>
          <span>Platform</span>
        </div>
      </div>
      <div className="golden-banner-container-right">
        <div className="golden-banner-container-right-upper">
          <img src={ZylaLogo} />
        </div>
        <div className="golden-banner-container-right-lower">
          <span>Your personal </span>
          <span>healthcare expert</span>
        </div>
      </div>
    </div>
  );
};

export default GoldenBanner;
